import React from 'react';
import FacilityEncounterSummary from '../../components/Claims/Analytics/FacilityEncounterSummary';
import ModuleNav, { MODULE_NAVS } from '../../components/ModuleNav';
import '../claims/claims-dashboard.css';

/**
 * Facility summary as its own page under Encounters. It renders the summary
 * directly — not inside the claims screen, whose saved-context restore used to
 * bounce this URL back to /claims — so nothing here redirects anywhere.
 */
export default function FacilitySummaryPage() {
  return (
    <div className="facility-summary-page">
      <div className="dashboard-page-stack" style={{ paddingBottom: 0 }}>
        <ModuleNav items={MODULE_NAVS.encounters} />
      </div>
      <FacilityEncounterSummary />
    </div>
  );
}
